<script>
</script>

<div class="fixed bg-[rgba(255,255,255,.3)] w-screen h-screen flex justify-center items-center z-[2000] left-0 top-0 bottom-0 right-0">
  <div class="loader"></div>
</div>

<style>
  .loader {
    width: 120px;
    height: 12px;
    border-radius: 20px;
    color: #01325d;
    border: 2px solid;
    position: relative;
  }
  .loader::before {
    content: "";
    position: absolute;
    margin: 2px;
    inset: 0 100% 0 0;
    border-radius: inherit;
    background: currentColor;
    animation: l6 2s infinite;
  }
  @keyframes l6 {
    100% {
      inset: 0;
    }
  }
</style>
